module.exports = __webpack_public_path__ + "img/7.55173a20.png";